import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpService } from '../service/http.service';
import { SchoolMemo } from '../school-memo';
import { MenuItem, ConfirmationService, SelectItemGroup } from 'primeng/api';
import { SchoolComment } from '../school-comment';
import { UserService } from '../service/user.service';
import { Country } from '../country';
import { CountryService } from '../service/country.service';
import { ProgrammeType } from '../programme-type';

import { ToastMessageService } from '../toast-message.service';
import { LviBankInformation } from '../lvi-bank-information';
import { SchoolContactEditComponent } from '../school-contact-edit/school-contact-edit.component';
import * as Editor from '../../libs/ckeditor';
import { SchoolService } from '../service/school.service';

@Component({
  selector: 'app-school-edit',
  templateUrl: './school-edit.component.html',
  styleUrls: ['./school-edit.component.css']
})
export class SchoolEditComponent implements OnInit {


  @ViewChild("editContact") schoolContactEditComponent!: SchoolContactEditComponent;

  nameIsNull = false;
  commentForm!: FormGroup;
  selectedComment!: SchoolComment | null;
  commentUpdateForm!: FormGroup;
  display = false;

  countries: Country[] = [];
  itemGroups: SelectItemGroup[] = [];
  programmeTypes: ProgrammeType[] = [];
  bankAccounts: LviBankInformation[] = [];

  items: MenuItem[] = [{
    label: "Modify",
    icon: 'pi pi-pencil',
    command: () => {
      this.display = true;
      this.initCommentUpdateForm();
    }
  },
  {
    label: "Delete",
    icon: "pi pi-trash",
    command: () => {
      this.confirmDelete();
    }
  }
  ];

  editorConfig: any = {
    toolbarGroups: [
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'clipboard', groups: ['clipboard', 'undo'] },
      { name: 'editing', groups: ['find', 'selection', 'spellchecker', 'editing'] },
      { name: 'forms', groups: ['forms'] },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
      { name: 'insert', groups: ['insert'] },
      { name: 'colors', groups: ['colors'] },
      { name: 'tools', groups: ['tools'] },
      { name: 'others', groups: ['others'] },
      { name: 'about', groups: ['about'] }
    ],
    removeButtons: "Save,Source,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Unlink,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,Table,PageBreak,SpecialChar,HorizontalRule,BGColor",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "250px",
    width: "100%"
  }

  editorConfigSmall: any = {
    toolbar: [
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting',] },
      { name: 'colors', items: ['TextColor', 'BGColor'] },
    ],
    toolbarLocation: "bottom",
    removeButtons: "Save,Source,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,Table,PageBreak,SpecialChar,HorizontalRule,BGColor",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "300px"
  }
  editorConfigDialog: any = {
    toolbar: [
      { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', '-', 'CopyFormatting',] },
      { name: 'colors', items: ['TextColor', 'BGColor'] },
    ],
    toolbarLocation: "bottom",
    removeButtons: "Save,Source,Templates,Preview,Cut,Copy,Paste,PasteText,PasteFromWord,Find,Replace,SelectAll,Scayt,Form,TextField,Checkbox,Textarea,Select,Button,ImageButton,HiddenField,RemoveFormat,CreateDiv,BidiLtr,BidiRtl,Language,Anchor,Unlink,Link,Maximize,ShowBlocks,About,Smiley,Subscript,Superscript,Print,NewPage,Blockquote,Flash,Table,PageBreak,SpecialChar,HorizontalRule,BGColor",
    contentsCss: ["body {font-size: small; font-family: Arial, Helvetica, sans-serif; line-height: 1.5;}", "p {margin:0;}"],
    defaultLabel: "Arial",
    height: "300px",
    width: "800px"
  }

  public Editor = Editor;

  constructor(
    private builder: FormBuilder,
    private httpService: HttpService,
    private confirmationService: ConfirmationService,
    public userService: UserService,
    private countryService: CountryService,
    public schoolService: SchoolService,
    private toastService: ToastMessageService
  ) { }

  ngOnInit() {
    this.httpService.getAllProgrammeTypes().subscribe(res => this.programmeTypes = res);
    this.countryService.getRegions().subscribe(res => {
      this.schoolService.itemGroups = res;
      this.schoolService.initCommentForm();
      this.schoolService.getComments();
    });
    this.httpService.getAllLviBankInformations().subscribe(res => {
      this.bankAccounts = res;
    });
  }

  lalala(){
    console.log(this.schoolContactEditComponent.contactForms);
  }

  addCountry() {
    let countries = this.schoolService.schoolForm.get("countries") as FormArray;
    countries.push(new FormControl(null));
  }

  addProgrammeType() {
    let programmeTypes = this.schoolService.schoolForm.get("programmeTypes") as FormArray;
    programmeTypes.push(new FormControl(null));
  }

  updateCountries() {
    let newCountryList = [];
    let countries = this.schoolService.schoolForm.get("countries") as FormArray;
    for (let country of countries.controls) {
      newCountryList.push(country.value);
    }
    if (newCountryList[0] == null) {
      this.toastService.addError("Error", "Country cannot be null");
      this.schoolService.updatingSchool = false;
      throw new Error("The first element of country has null value");
    }
    this.schoolService.selectedSchool.countryList = newCountryList;
  }

  removeCountry(index: number){
    let countries = this.schoolService.schoolForm.get("countries") as FormArray;
    if(countries.length > 1){
      countries.removeAt(index);
    }
  }

  updateProgrammeTypes() {
    let newProgrammeTypes = [];
    let programmeTypes = this.schoolService.schoolForm.get("programmeTypes") as FormArray;
    for (let programmeType of programmeTypes.controls) {
      newProgrammeTypes.push(programmeType.value);
    }
    this.schoolService.selectedSchool.programmeTypes = newProgrammeTypes;
    if (newProgrammeTypes[0] == null) {
      this.toastService.addError("Error", "Programme type cannot be null");
      this.schoolService.updatingSchool = false;
      throw new Error("The first element of programmeTypes has null value");
    }
  }

  removeProgrammeType(index: number){
    let programmeTypes = this.schoolService.schoolForm.get("programmeTypes") as FormArray;
    if(programmeTypes.length > 1){
      programmeTypes.removeAt(index);
    }
  }

  get programmeTypeFormArray(){
    let programmeTypeFormArray = this.schoolService.schoolForm.get("programmeTypes") as FormArray;
    return programmeTypeFormArray.controls;
  }

  get countryFormArray(){
    let countryForm = this.schoolService.schoolForm.get("countries") as FormArray;
    return countryForm.controls;
  }

  get programmeInfoFormArray(){
    let programmeInfosForm = this.schoolService.schoolForm.get('programmeInformations') as FormArray;
    return programmeInfosForm.controls;
  }

  resetCommentForm() {
    this.commentForm.get("title")!.setValue("");
    this.commentForm.get("body")!.setValue("");
  }

  initCommentUpdateForm() {
    this.commentUpdateForm = this.builder.group({
      title: [this.selectedComment!.title, Validators.required],
      body: [this.selectedComment!.body, Validators.required]
    });
  }
  resetCommentUpdateForm() {
    this.commentUpdateForm.get("title")!.setValue("");
    this.commentUpdateForm.get("body")!.setValue("");
  }

  sendForm() {
    this.nameIsNull = false;
    if (this.schoolService.schoolForm.value.name == "") {
      this.nameIsNull = true;
      return;
    }
    this.schoolService.selectedSchool.name = this.schoolService.schoolForm.value.name;
    let comment = "";
    if (this.schoolService.schoolForm.value.comment) {
      comment = this.schoolService.schoolForm.value.comment;
    }
    if (this.schoolService.selectedSchool.schoolMemo == null) {
      this.schoolService.selectedSchool.schoolMemo = new SchoolMemo(
        comment, null
      );
    } else {
      this.schoolService.selectedSchool.schoolMemo.comment = comment;
    }
    this.schoolService.updatingSchool = true;
    this.updateCountries();
    this.updateProgrammeTypes();
    this.schoolService.updateProgrammeInformations();
    this.schoolService.selectedSchool.internalName = this.schoolService.schoolForm.value.internalName;
    this.schoolService.selectedSchool.officialName = this.schoolService.schoolForm.value.officialName;
    this.schoolService.selectedSchool.street = this.schoolService.schoolForm.value.street;
    this.schoolService.selectedSchool.code = this.schoolService.schoolForm.value.code;
    this.schoolService.selectedSchool.siteUrl = this.schoolService.schoolForm.value.siteUrl;
    this.schoolService.selectedSchool.postalCode = this.schoolService.schoolForm.value.postalCode;
    this.schoolService.selectedSchool.city = this.schoolService.schoolForm.value.city;
    this.schoolService.selectedSchool.phoneNumber = this.schoolService.schoolForm.value.phoneNumber;
    this.schoolService.selectedSchool.appointmentTime = this.schoolService.schoolForm.value.appointmentTime;
    this.schoolService.selectedSchool.requireStudentAddress = this.schoolService.schoolForm.value.requireStudentAddress;
    this.schoolService.selectedSchool.requireStudentPhoneNumber = this.schoolService.schoolForm.value.requireStudentPhoneNumber;
    this.schoolService.selectedSchool.lviPageUrl = this.schoolService.schoolForm.value.lviPageUrl;
    this.schoolService.selectedSchool.googleSheetUrl = this.schoolService.schoolForm.value.googleSheetUrl;
    this.schoolService.selectedSchool.defaultBank = this.schoolService.schoolForm.value.defaultBank;
    this.schoolService.selectedSchool.language = this.schoolService.schoolForm.value.language;
    this.schoolService.selectedSchool.emergencyPhoneNumber = this.schoolService.schoolForm.value.emergencyPhoneNumber;
    this.schoolService.selectedSchool.requireSchoolAddress = this.schoolService.schoolForm.value.requireSchoolAddress;
    this.schoolService.selectedSchool.externalName = this.schoolService.schoolForm.value.externalName;
    this.schoolService.selectedSchool.homeCountry = this.schoolService.schoolForm.value.homeCountry;
    this.httpService.putSchool(this.schoolService.selectedSchool).subscribe(school => {
      this.schoolService.selectedSchool = school;
      this.schoolService.updatingSchool = false;
      console.log("success");
      this.toastService.addSuccess("updated", "school is successfully updated.");
      this.schoolService.initCourseForm();
      let programmeInformations = this.schoolService.schoolForm.get("programmeInformations") as FormArray;
      programmeInformations.clear();
      this.updateSchoolProgrammeInformations();
      this.updateContacts();
    }, error => {
      this.schoolService.updatingSchool = false;
      this.toastService.addError("error", "update failed...")
      console.error(error);
    });
  }

  updateSchoolProgrammeInformations(){
    this.httpService.getProgrammeInformationsBySchoolId(this.schoolService.selectedSchool.id!).subscribe(res => {
      this.schoolService.selectedSchool.programmeInformationList = res;
      this.schoolService.initProgrammeInformationsForm();
    });
  }

  postComment() {
    let schoolComment = new SchoolComment(
      this.commentForm.value.title,
      this.commentForm.value.body
    );
    this.httpService.postSchoolComment(schoolComment, this.schoolService.selectedSchool.id!)
      .subscribe(() => {
        this.resetCommentForm();
        this.schoolService.getComments();
      });
  }

  updateContacts(){
    this.schoolContactEditComponent.submitAll();
  }

  confirmDelete() {
    this.confirmationService.confirm({
      header: "Supprimer la publication ?",
      message: "Voulez-vous vraiment supprimer cette publication ?",
      accept: () => {
        this.httpService.deleteSchoolComment(this.selectedComment!.id!).subscribe(() => {
          this.selectedComment = null;
          this.toastService.addSuccess("Success", "Post is successfully deleted.");
          this.schoolService.getComments();
        });
      }
    });
  }

  updateSelectedComment(comment: SchoolComment) {
    this.selectedComment = comment;
  }

  updateComment() {
    this.selectedComment!.body = this.commentUpdateForm.value.body.trim();
    this.selectedComment!.title = this.commentUpdateForm.value.title.trim();
    this.httpService.putSchoolComment(this.selectedComment!).subscribe(() => {
      this.selectedComment = null;
      this.display = false;
      this.resetCommentUpdateForm();
    }, error => {
      this.toastService.addError("Update failed", error.error.message);
    });
  }

  compareId(item: any, selected: any) {
    return item.id === selected.id;
  }

}
